import React, { useState, useEffect, useRef, useCallback } from 'react';
import CompanyRepo from '../../utils/repository/companyRepo';
import Loader from '../../components/loader';
import { Header, List } from 'semantic-ui-react';
import RouteC from '../../constnats/routeConstants';
import { Link } from 'react-router-dom';
import CompanyUtils from '../../utils/companyUtils';
import CompanyLogo from '../../components/company/companyLogo';
import { CompanyInfoType } from '../../schemas/company.schemas';
import './styles.css'

function Companies() {
    const [companies, setCompanies] = useState<CompanyInfoType[]>([]);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [hasMore, setHasMore] = useState(true);
    const sentinelRef = useRef<HTMLDivElement>(null);

    const fetchPage = useCallback((pageToFetch: number) => {
        setLoading(true);
        CompanyRepo.list(pageToFetch, (response: any) => {
            setCompanies((prev) => [...prev, ...response.data.content]);
            setHasMore(!response.last);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        fetchPage(page);
    }, [page, fetchPage]);

    useEffect(() => {
        const sentinel = sentinelRef.current;
        if (!sentinel) {
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && hasMore && !loading) {
                setPage((prev) => prev + 1);
            }
        });

        observer.observe(sentinel);
        return () => observer.disconnect();
    }, [hasMore, loading]);

    const initialLoading = loading && companies.length === 0;

    return (
        <div>
            <Header as="h2" textAlign='center'>Companies</Header>
            {initialLoading ? <Loader /> : <CompaniesList companies={companies} />}
            {loading && companies.length > 0 && <Loader />}
            {hasMore && <div ref={sentinelRef} />}
        </div>
    );
}

const CompaniesList = React.memo(function CompaniesList({ companies }: { companies: CompanyInfoType[] }) {
    let lastName = "";

    return companies.length === 0 ? <>No companies found</> :
        <List divided verticalAlign='middle'>
            {companies.map((c) => {
                const companyName = c.name.trim();
                const letterItem = companyName.charAt(0).toUpperCase() !== lastName.charAt(0) ?
                    <b>{c.name.charAt(0).toUpperCase()}</b>
                    : <></>;

                lastName = companyName.toUpperCase();

                return <List.Item key={c.id}>
                    {letterItem}
                    <Link to={RouteC.COMPANY_PUBLIC + c.id}>
                        <div className='company-item-container'>
                            <CompanyLogo className='company-heading-logo' companyId={c.id} />
                            <List.Content>{CompanyUtils.getCompanyTitle(c)}</List.Content>
                        </div>
                    </Link>
                </List.Item>
            })}
        </List>
});

export default Companies;
